// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          no_results: "No {{unit}} found",
          results_found: "We found {{count}} {{unit}} matching your preferences.",
          banner_title: "Looking for the Best Off-Plan Deals in Dubai?",
          banner_subtitle: "Join our investor network and get early access to exclusive properties, expert advice, and VIP pricing.",
          get_in_touch: "Get in Touch",
          brand_description: "JustOffplan.ai is your smart gateway to AI-curated off-plan properties in Dubai. Discover exclusive homes and investment-ready projects across top UAE communities.",
          powered_by: "Powered by Alkhail Real Estate | Operating in Dubai since 2006",
          explore_properties: "Explore Properties",
          popular_areas: "Popular Areas",
          legal: "Legal",
          privacy_policy: "Privacy Policy",
          terms_of_use: "Terms of Use",
          resources: "Resources",
          contact_us: "Contact Us",
          blog: "Blog",
          faq: "FAQ",
          lets_talk: "Let’s Talk",
          chat_on_whatsapp: "Chat with us on WhatsApp for instant assistance.",
          chat_now: "Chat on WhatsApp",
          exclusive_deals: "Get Exclusive Deals",
          exclusive_cta: "Get exclusive launch offers & hot deals weekly.",
          follow_us: "Follow Us",

          footer_cta: "Looking for your dream property?",
          subscribe_text: "Get the hottest off-plan deals:",
          placeholder_email: "Enter your email",
          subscribe_button: "Subscribe",
          language: "Language",
          english: "English",
          arabic: "Arabic",
          rights_reserved: "All rights reserved.",

          quickLinks: {
            buy_apartments: "Buy Apartments in Dubai",
            luxury_villas: "Luxury Villas for Sale in Dubai",
            offplan_townhouses: "Off-Plan Townhouses in UAE",
            latest_ai_projects: "Latest AI-Curated Projects",
            investment_penthouses: "Investment-Friendly Penthouses",
            premium_offplan: "Premium Off-Plan Properties in Dubai",
            full_floors_sale: "Exclusive Dubai Full Floors for Sale",
            duplex_apartments: "Duplex Apartments for Investment",
            hotel_apartments: "High-End Hotel Apartments in Dubai",
            commercial_properties: "Commercial Properties in Dubai for Sale",
            retail_properties: "Retail Properties in UAE for Investment",
            uae_developers: "UAE Developers",
            working_hours: "Mon–Fri: 9AM–6PM GST",
          },
          amenities: {
             amenities_section_title:"Amenities & Facilities",
  
  },
  "contact_form": {
    "get_in_touch": "Get in Touch with Us",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "select_role": "Select Your Role",
    "select_role_placeholder": "-- Select --",
    "agent": "Agent",
    "buyer": "Buyer",
    "just_exploring": "Just Exploring",
    "message": "Message",
    "send_message": "Send Message",
    "sending": "Sending...",
    "failed_message": "Failed to send message.",
    "error_message": "An error occurred while sending your message.",
    "default_message": "I am interested in this property",
    "please_contact_me": "Please contact me"
  }
,

          popularAreas: {
            palm_jumeirah: "Palm Jumeirah",
            dubai_hills: "Dubai Hills",
            downtown_dubai: "Downtown Dubai",
            jvc: "Jumeirah Village Circle",
          }, searchFilter: {
         "title": "Still haven’t found what you’re looking for?",
        "description": "Use the advanced filters below to fine-tune your search — and let our smart AI match you with your dream property effortlessly.",
        reset: "Reset",
        whatLookingFor: "What are you looking for?",
        budget: "Please enter your budget (optional)",
        handover: "When should it be ready?",
        city: "Preferred City",
        developer: "Preferred Developer",
        project: "Project Name",
        keywords: "Enter keywords",
        keywordsPlaceholder: "Example: real estate, dubai, investment",
        findProperties: "Find Properties",
        searching: "Searching...",
        perfect_property_heading: "Let’s Find You the Perfect Property",
        advance_filter: "Advance Filter",        
      },

          hero_title_main: "UAE’s First AI Platform for",
          hero_title_highlight: "Off-Plan Properties",
          hero_subtitle_line1: "Find your ideal home or investment with AI.",
          hero_subtitle_line2: "Direct from the developer, no agents involved.",
          hero_browse_properties: "Browse Properties",
          hero_learn_more: "Learn more about JustOffPlan.ai",
          properties_section_heading: "Your Ideal Property Is Here",
          loading_properties: "Loading properties...",
          no_properties_found: "No properties found.",
          loading: "Loading...",
          load_more: "Load More",
        
          unit_types: {
  apartment: "Apartment",
  villa: "Villa",
  studio: "Studio",
  penthouse: "Penthouse",
  townhouse: "Townhouse",
  duplex: "Duplex",
  hotel_apartment: "Hotel Apartment",
  full_floor: "Full Floor"
}
,
about: {
  heading: "We’re transforming how people invest in Dubai real estate",
  intro: "Our platform bridges the gap between property buyers and Dubai’s top developers, offering seamless access to off-plan properties with smarter investment tracking.",
  mission_title: "Our Mission",
  mission_1: "We are dedicated to transforming the off-plan property buying experience in Dubai by delivering transparent listings, expert insights, and verified project details.",
  mission_2: "Our commitment goes beyond listings — we build trust, foster long-term value, and help investors navigate Dubai’s dynamic real estate market with confidence.",
  stats: {
    listings: "Verified Off-Plan Listings",
    value: "Total Project Value",
    partners: "Trusted Developer Partners",
    satisfaction: "Customer Satisfaction"
  },
  values_title: "Our Values",
  values: {
    world_class: "Be world-class",
    insights: "Share insights",
    innovate: "Always innovating",
    supportive: "Be supportive",
    responsible: "Take responsibility",
    enjoy: "Enjoy the journey"
  },
  values_desc: {
    world_class: "We deliver top-tier listings and a premium experience.",
    insights: "We empower investors with the latest market knowledge.",
    innovate: "We continuously improve to meet market needs.",
    supportive: "We guide each buyer at every step of their journey.",
    responsible: "We stand by our data, support, and promises.",
    enjoy: "We believe investing should be exciting and rewarding."
  }

},

  "thank_you_page": {
    "thank_you": "Thank you!",
    "message": "Your message has been received. We’ll get in touch with you shortly.",
    "back_to_home": "Back to Home"
  }

,

  "property": {
    "foundResults": "We found {{count}} {{type}} matching your preferences.",
    "noResults": "No {{type}} found"
  }
,

exclusive_projects: "Exclusive Projects",
latest_projects: "Latest Projects",



         emirates: {
          
            dubai: "Dubai",
            abu_dhabi: "Abu Dhabi",
            sharjah: "Sharjah",
            ajman: "Ajman",
            fujairah: "Fujairah",
            ras_al_khaimah: "Ras Al Khaimah",
            umm_al_quwain: "Umm Al Quwain"
          },"communities": {
            "projects": "Projects",
    "in": "in",
    "price_range": "Price Range",
    "from_aed": "From (AED)",
    "to_aed": "To (AED)",
    "apply_filter": "Apply Filter",
    "clear_filter": "Clear Filter",
    "no_properties": "No properties available",
    "loading": "Loading...",
    "load_more": "Load More",
            "AI_found": "AI found",
          "community_count": "community",
          "communities": "communities",
          "in": "in",
          "the_UAE": "the UAE",
          "with": "with",
          "active": "active",
          "project_count": "project",
          "projects": "projects",
          "title": "Where would you like to live in the UAE?",
          "description": "Our AI has handpicked top-performing communities across every emirate - just tap and explore.",
          "show_all_button": "Show All Cities",
          "ai_found": "AI found {{count}} community in {{emirate}} with {{projects}} active projects.",
          "projects": "Projects",
          "min_price": "Min Price : AED {{price}}",
          "max_price": "Max Price : AED {{price}}",     
          "the_uae": "the UAE",
          "remraam": "Remraam",
          "alyelayiss_2": "AlYelayiss 2",
          "zaabeel_second": "Zaabeel Second",
          "port_rashid": "Port Rashid",
          "jumeirah-island-one": "Jumeirah Island One",
          "albarsha_south": "Albarsha South",
          "alshamkha": "Alshamkha",
          "palm_jabal_ali": "Palm Jabal Ali",
          "ramhan_island": "Ramhan Island",
          "sharm": "Sharm",
          "bluewaters_bay": "Bluewaters Bay",
          "city_walk": "City Walk",
          "wadi_alsafa_4": "Wadi AlSafa 4",
          "wadi_alsafa_2": "Wadi AlSafa 2",
          "mbr_district_one": "Mbr District One",
          "alyasmeen": "Alyasmeen",
          "jumeirah_park": "Jumeirah Park",
          "albarari": "Albarari",
          "al_khalidiya": "Al Khalidiya",
          "jumeirah_heights": "Jumeirah Heights",
          "dubai_internet_city": "Dubai Internet City",
          "alzahya": "Alzahya",
          "me´aisem_first": "Me´Aisem First",
          "mohammed_bin_rashid_city(mbr_city)": "Mohammed Bin Rashid City(MBR City)",
          "jumeirah_beach_residence(jbr)": "Jumeirah Beach Residence(JBR)",
          "al_barsha_1": "Al Barsha 1",
          "mirdif": "Mirdif",
          "madinat_jumeirah_living": "Madinat Jumeirah Living",
          "albelaida": "Albelaida",
          "uptown,_althanyah_fifth": "Uptown, AlThanyah Fifth",
          "tilal_alghaf": "Tilal AlGhaf",
          "alhamra_island": "Alhamra Island",
          "dubai_design_district": "Dubai Design District",
          "martime_city": "Martime City",
          "la_mer": "La Mer",
          "nadd_al_shiba": "Nadd Al Shiba",
          "ghaf_woods": "Ghaf Woods",
          "al_tay": "Al Tay",
          "warsan_fourth": "Warsan Fourth",
          "al_maryah_island": "Al Maryah Island",
          "free_zone": "Free Zone",
          "dubai_industrial_city": "Dubai Industrial City",
          "alheliow1": "Alheliow1",
          "jebel_ali_village": "Jebel Ali Village",
          "hamriya_west": "Hamriya West",
          "nad_alsheba_1": "Nad Alsheba 1",
          "zayed_city": "Zayed City",
          "barashi": "Barashi",
          "wadi_al_safa_7": "Wadi Al Safa 7",
          "alnuaimia_1": "Alnuaimia 1",
          "alrashidiya_1": "Alrashidiya 1",
          "alraha": "Alraha",
          "alheliow2": "Alheliow2",
          "ain_al_fayda": "Ain Al Fayda",
          "golf_city": "Golf City",
          "al_hamra_village": "Al Hamra Village",
          "almaryah": "Almaryah",
          "khalifa_city": "Khalifa City",
          "rukan_community": "Rukan Community",
          "ajmal_makan_city": "Ajmal Makan City",
          "town_square_dubai": "Town Square Dubai",
          "legends": "Legends",
          "waterfront_city": "Waterfront City",
          "alzorah": "Alzorah",
          "alhamriyah": "Alhamriyah",
          "discovery_gardens": "Discovery Gardens",
          "alrashidiya_3": "Alrashidiya 3",
          "alkifaf": "AlKifaf",
          "alsafouh_first": "AlSafouh First",
          "world_islands": "World Islands",
          "marina": "Marina",
          "damac_islands": "Damac Islands",
          "al_yelayiss_5": "Al Yelayiss 5",
          "the_heights_country_club": "The Heights Country Club",
          "the_oasis": "The Oasis",
          "dubai_media_city": "Dubai Media City",
          "sheikh_zayed_road,_alsafa": "Sheikh Zayed Road, Alsafa",
          "damac_hills": "Damac Hills",
          "wadi_alsafa_3": "Wadi AlSafa 3",
          "damac_hills_2": "Damac Hills 2",
          "damac_lagoons": "Damac Lagoons",
          "al_yelayiss_1": "Al Yelayiss 1",
          "dubai_investment_park_2": "Dubai Investment Park 2",
          "bukadra": "Bukadra",
          "maryam_island": "Maryam Island",
          "unknown_district": "Unknown District",
          "the_valley": "The Valley",
          "rashid_yachts_and_marina": "Rashid Yachts and Marina",
          "emaar_south": "Emaar South",
          "siniya_island": "Siniya Island",
          "international_city": "International City",
          "downtown": "Downtown",
          "emaar_beachfront": "Emaar Beachfront",
          "dubai_creek_harbour": "Dubai Creek Harbour",
          "alsafouh_second": "Alsafouh Second",
          "alfaqa'": "AlFaqa'",
          "albarsha_south_fifth": "AlBarsha South Fifth",
          "dubai_water_canal": "Dubai Water Canal",
          "alsafa": "Alsafa",
          "jumeirah_golf_estates(jge)": "Jumeirah Golf Estates(JGE)",
          "dubai-science-park": "Dubai Science Park",
          "dubai_hills": "Dubai Hills",
          "mina_alarab,_hayat_islands": "Mina AlArab, Hayat Islands",
          "hayat_islands": "Hayat Islands",
          "dubai_investment_park": "Dubai Investment Park",
          "mina_alarab": "Mina Alarab",
          "liwan": "Liwan",
          "jumeirah_island": "Jumeirah island",
          "aljurf": "Aljurf",
          "alrahmaniya": "Alrahmaniya",
          "raha_island": "Raha Island",
          "albarsha_south_fourth": "AlBarsha South Fourth",
          "masdar_city": "Masdar City",
          "expo_city": "Expo City",
          "alheerah": "Alheerah",
          "alsuyoh_suburb": "Alsuyoh Suburb",
          "dubai_harbour": "Dubai Harbour",
          "dubai_healthcare_city": "Dubai Healthcare City",
          "almamzar": "Almamzar",
          "dubai_silicon_oasis": "Dubai Silicon Oasis",
          "trade_center_first": "Trade Center First",
          "sports_city": "Sports City",
          "majan": "Majan",
          "dubai_marina": "Dubai Marina",
          "dubai_motor_city": "Dubai Motor City",
          "alreem_island": "Alreem Island",
          "dubai_downtown": "Dubai Downtown",
          "international_city_phase_(2)": "International City Phase (2)",
          "alsatwa": "Alsatwa",
          "barsha_heights": "Barsha Heights",
          "dubai_sports_city": "Dubai Sports City",
          "jumeirah_2": "Jumeirah 2",
          "jlt": "JLT",
          "warsan_first": "Warsan First",
          "aljada": "Aljada",
          "alamerah": "Alamerah",
          "almanama": "Almanama",
          "alsajaa": "Alsajaa",
          "aljadaf": "Aljadaf",
          "tilal": "Tilal",
          "jabal_ali_first": "Jabal Ali First",
          "studio_city": "Studio City",
          "meydan_d11": "Meydan D11",
          "fahid_island": "Fahid Island",
          "palm_jumeirah": "Palm Jumeirah",
          "saadiyat_island": "Saadiyat Island",
          "ghantoot": "Ghantoot",
          "meydan": "Meydan",
          "dubai_international_financial_centre_(difc)": "Dubai International Financial Centre (DIFC)",
          "jvt": "JVT",
          "jumeirah_garden_city": "Jumeirah Garden City",
          "city_of_arabia": "City Of Arabia",
          "madinat_almataar": "Madinat Almataar",
          "yas_island": "Yas Island",
          "mbr_city_d11": "MBR City D11",
          "ras_alkhor_ind._first": "Ras AlKhor Ind. First",
          "sobha_hartland_2": "Sobha Hartland 2",
          "sobha_hartland": "Sobha Hartland",
          "dubai-south": "Dubai South",
          "dubai_maritime_city": "Dubai Maritime City",
          "alraudah": "Alraudah",
          "jabal_ali_industrial_second": "Jabal Ali Industrial Second",
          "dubai_production_city": "Dubai Production City",
          "reem_island": "Reem Island",
          "dubai_land_residence_complex": "Dubai Land Residence Complex",
          "jvc": "JVC",
          "al_barsha_south_second": "Al Barsha South Second",
          "dubai_islands": "Dubai Islands",
          "muwaileh": "Muwaileh",
          "arjan": "Arjan",
          "almarjan_island": "Almarjan Island",
          "alwasl": "Alwasl",
          "alfurjan": "Alfurjan",
          "wadi_alsafa_5": "Wadi AlSafa 5",
          "motor_city": "Motor City",
          "business_bay": "Business Bay",
          "show_all_cities": "Show All Cities",
        },"navbar": {
        "home": "Home",
        "exclusive": "Exclusive",
        "latest": "Latest",
        "about": "About",
        "contact": "Contact",
        "blog": "Blog",
        "login": "Login",
        "signup": "Sign Up",
        "logout": "Logout",
        "profile": "My Profile",
        "settings": "Settings",
      }
      ,
      "static": {
        "latest_properties": "Latest Projects",
        "off_plan": "Offplan",
        "ready": "Ready",
        "coming_soon": "Coming Soon",
        "load_more": "Load More",
        "loading": "Loading...",
        "loading_properties": "Loading properties...",
        "no_properties": "No properties found.",
        "sqft": "sqft"
      }
      ,"currency": {
        "dirham": "AED",
        "ask_for_price": "Ask for Price",
      },
      "tabs": {
  "overview": "Overview",
    "payment_plan":"Payment plan" ,
    "available_units": "Available Units",
    "starting_price": "Starting Price",
    "area": "Area",
    "rooms":"Rooms",
},
  "contact": {
    "get_in_touch": "Get in Touch",
    "question_info": "Have a question or need more info? Fill out the form below and we'll get back to you shortly."
  },



        }
      },
      ar: {
        translation: {
           no_results: "لم يتم العثور على {{unit}}",
            results_found: "وجدنا {{count}} {{unit}} تطابق تفضيلاتك.",
          banner_title: "هل تبحث عن أفضل عروض العقارات في دبي؟",
          banner_subtitle: "انضم إلى شبكة المستثمرين لدينا واحصل على وصول مبكر إلى العقارات الحصرية والنصائح من الخبراء وأسعار VIP.",
          get_in_touch: "تواصل معنا",
          brand_description: "JustOffplan.ai هو بوابتك الذكية إلى عقارات دبي المخطط لها والمدعومة بالذكاء الاصطناعي. اكتشف منازل حصرية ومشاريع جاهزة للاستثمار في أبرز مجتمعات الإمارات.",
          powered_by: "برعاية الخيل العقارية | تعمل في دبي منذ عام 2006",
          explore_properties: "استكشف العقارات",
          popular_areas: "المناطق الشهيرة",
          legal: "قانوني",
          privacy_policy: "سياسة الخصوصية",
          terms_of_use: "شروط الاستخدام",
          resources: "الموارد",
          contact_us: "اتصل بنا",
          blog: "المدونة",
          faq: "الأسئلة الشائعة",

          lets_talk: "دعونا نتحدث",
          chat_on_whatsapp: "تحدث معنا على واتساب للحصول على المساعدة الفورية.",
          chat_now: "الدردشة على واتساب",
          exclusive_deals: "احصل على عروض حصرية",
          exclusive_cta: "احصل على عروض إطلاق حصرية وصفقات ساخنة أسبوعيًا.",
          follow_us: "تابعنا",

          footer_cta: "هل تبحث عن عقار أحلامك؟ تواصل معنا عبر",
          subscribe_text: "احصل على أحدث عروض العقارات:",
          placeholder_email: "أدخل بريدك الإلكتروني",
          subscribe_button: "اشترك",
          language: "اللغة",
          english: "الإنجليزية",
          arabic: "العربية",
          rights_reserved: "جميع الحقوق محفوظة.",
          working_hours: "من الاثنين إلى الجمعة: 9 صباحًا - 6 مساءً بتوقيت الخليج",
          searchFilter: {
        "title": "هل لم تجد ما تبحث عنه؟",
        "description": "استخدم الفلاتر المتقدمة أدناه لتضييق بحثك — دع ذكائنا الاصطناعي يطابقك مع عقار أحلامك بسهولة.",
        
        whatLookingFor: "ما الذي تبحث عنه؟",
        budget: "أدخل ميزانيتك (اختياري)",
        handover: "متى يجب أن يكون جاهزًا؟",
        city: "المدينة المفضلة",
        developer: "المطور المفضل",
        project: "اسم المشروع",
        keywords: "أدخل الكلمات الرئيسية",
        keywordsPlaceholder: "مثال: عقارات، دبي، استثمار",
        findProperties: "ابحث عن عقارات",
        searching: "جاري البحث...",
         perfect_property_heading: "دعنا نساعدك في العثور على العقار المثالي",
        reset: "إعادة تعيين",
        advance_filter: "فلتر متقدم"
      },
          quickLinks: {
            buy_apartments: "شراء شقق في دبي",
            luxury_villas: "فلل فاخرة للبيع في دبي",
            offplan_townhouses: "تاون هاوس على المخطط في الإمارات",
            latest_ai_projects: "أحدث المشاريع المعتمدة على الذكاء الاصطناعي",
            investment_penthouses: "بنتهاوس مناسب للاستثمار",
            premium_offplan: "عقارات مميزة على المخطط في دبي",
            full_floors_sale: "طوابق كاملة للبيع حصريًا في دبي",
            duplex_apartments: "شقق دوبلكس للاستثمار",
            hotel_apartments: "شقق فندقية فاخرة في دبي",
            commercial_properties: "عقارات تجارية للبيع في دبي",
            retail_properties: "عقارات للبيع بالتجزئة في الإمارات",
            uae_developers: "مطورون في الإمارات"
          },
          popularAreas: {
            palm_jumeirah: "نخلة جميرا",
            dubai_hills: "تلال دبي",
            downtown_dubai: "وسط مدينة دبي",
            jvc: "قرية جميرا الدائرية",
          },
          hero_title_main: "أول منصة مدعومة بالذكاء الاصطناعي في الإمارات",
          hero_title_highlight: "للعقارات على المخطط",
          hero_subtitle_line1: "اعثر على منزلك أو استثمارك المثالي بمساعدة الذكاء الاصطناعي.",
          hero_subtitle_line2: "مباشرة من المطور، بدون وسطاء.",
          hero_browse_properties: "تصفح العقارات",
          hero_learn_more: "اعرف المزيد",
          properties_section_heading: "العقار المثالي لك هنا",
          loading_properties: "جارٍ تحميل العقارات...",
          no_properties_found: "لم يتم العثور على عقارات.",
          loading: "جارٍ التحميل...",
          load_more: "تحميل المزيد",

"navbar": {
  "home": "الرئيسية",
  "exclusive": "حصري",
  "latest": "أحدث المشاريع",
  "about": "من نحن",
  "contact": "تواصل معنا",
  "blog": "مدونة",
  "login": "تسجيل الدخول",
   "signup": "إنشاء حساب",
  "logout": "تسجيل الخروج",
  "profile": "ملفي الشخصي",
  "settings": "الإعدادات",
}
, 
  "contact": {
    "get_in_touch": "تواصل معنا",
    "question_info": "هل لديك سؤال أو تحتاج إلى مزيد من المعلومات؟ قم بملء النموذج أدناه وسنعود إليك قريبًا."
  },

          unit_types: {
  apartment: "شقة",
  villa: "فيلا",
  studio: "استوديو",
  penthouse: "بنتهاوس",
  townhouse: "تاون هاوس",
  duplex: "دوبلكس",
  hotel_apartment: "شقة فندقية",
  full_floor: "طابق كامل"
}
,
"currency": {
  "dirham": "درهم",
  "ask_for_price": "اطلب السعر"
}
,
          emirates: {
            "all": "الكل",
            dubai: "دبي",
            abu_dhabi: "أبو ظبي",
            sharjah: "الشارقة",
            ajman: "عجمان",
            fujairah: "الفجيرة",
            ras_al_khaimah: "رأس الخيمة",
            umm_al_quwain: "أم القيوين"
          }, "communities": {
            "projects": "مشاريع",
    "in": "في",
    "price_range": "نطاق السعر",
    "from_aed": "من (درهم)",
    "to_aed": "إلى (درهم)",
    "apply_filter": "تطبيق الفلتر",
    "clear_filter": "إزالة الفلتر",
    "no_properties": "لا توجد عقارات متاحة",
    "loading": "جار التحميل...",
    "load_more": "تحميل المزيد",
             "AI_found": "تم العثور على الذكاء الاصطناعي",
              "community_count": "مجتمع",
              "communities": "مجتمعات",
              "in": "في",
              "the_UAE": "الإمارات العربية المتحدة",
              "with": "مع",
              "active": "نشط",
              "project_count": "مشروع",
              "projects": "مشاريع",
             "title": "أين ترغب بالعيش في الإمارات؟",
    "description": "اختار ذكاءنا الاصطناعي أفضل المجتمعات في كل إمارة - فقط اضغط واستكشف",
    "show_all_button": "عرض جميع المدن",
    "ai_found": "تم العثور على {{count}} مجتمع في {{emirate}} مع {{projects}} مشاريع نشطة",
    "projects": "مشاريع",
    "min_price": "أقل سعر: AED {{price}}",
    "max_price": "أعلى سعر: AED {{price}}",
   "the_uae": "الإمارات العربية المتحدة",
 "remraam": "رمرام",
  "alyelayiss-2": "اليلايس 2",
  "zaabeel-second": "الزعبيل الثانية",
  "port-rashid": "ميناء راشد",
  "jumeirah-island-one": "جزيرة جميرا 1",
  "albarsha-south": "البرشاء جنوب",
  "alshamkha": "الشامخة",
  "palm-jabal-ali": "نخلة جبل علي",
  "ramhan-island": "جزيرة رمحان",
  "sharm": "شرم",
  "bluewaters-bay": "بلو ووترز باي",
  "city-walk": "سيتي ووك",
  "wadi-alsafa-4": "وادي الصفا 4",
  "wadi-alsafa-2": "وادي الصفا 2",
  "mbr-district-one": "حي محمد بن راشد 1",
  "alyasmeen": "الياسمين",
  "jumeirah-park": "حديقة جميرا",
  "albarari": "البراري",
  "al-khalidiya": "الخالدية",
   "jumeirah-heights": "مرتفعات جميرا",
  "dubai-internet-city": "مدينة دبي للإنترنت",
  "alzahya": "الزاهية",
  "me-aisem-first": "مقسم الأولى",
  "mohammed-bin-rashid_citymbr_city": "مدينة محمد بن راشد",
  "jumeirah-beach-residencejbr": "جميرا بيتش ريزيدنس (JBR)",
  "al-barsha-1": "البرشاء 1",
  "mirdif": "مردف",
  "madinat-jumeirah-living": "مدينة جميرا ليفينج",
  "albelaida": "البليدة",
  "uptown-althanyah-fifth": "أبتاون، الثنية الخامسة",
  "tilal-alghaf": "تلال الغاف",
  "alhamra-island": "جزيرة الحمراء",
  "dubai-design-district": "حي دبي للتصميم",
  "martime-city": "المدينة البحرية",
  "la-mer": "لا مير",
  "nadd-al-shiba": "ند الشبا",
  "ghaf-woods": "غاف وودز",
  "al-tay": "الطَي",
  "warsan-fourth": "ورسان الرابعة",
   "al-maryah-island": "جزيرة المارية",
  "free-zone": "المنطقة الحرة",
  "dubai-industrial_city": "مدينة دبي الصناعية",
  "alheliow1": "الحليو 1",
  "jebel-ali-village": "قرية جبل علي",
  "hamriya-west": "الحمرية الغربية",
  "nad-alsheba-1": "ند الشبا 1",
  "zayed-city": "مدينة زايد",
  "barashi": "البرشي",
  "wadi-al-safa-7": "وادي الصفا 7",
  "alnuaimia_1": "النعيمية 1",
  "alrashidiya-1": "الرشدية 1",
  "alraha": "الراحة",
  "alheliow2": "الحليو 2",
  "ain-al-fayda": "عين الفايضة",
  "golf-city": "مدينة الجولف",
  "al-hamra-village": "قرية الحمراء",
  "almaryah": "المارية",
  "khalifa-city": "مدينة خليفة",
  "rukan-community": "مجتمع روكان",
   "ajmal-makan_city": "مدينة أجمل مكان",
  "town-square-dubai": "تاون سكوير دبي",
  "legends": "ذا ليجيندز",
  "waterfront-city": "مدينة الواجهة البحرية",
  "alzorah": "الزورا",
  "alhamriyah": "الحمريه",
  "discovery-gardens": "ديسكفري جاردنز",
  "alrashidiya-3": "الرشدية 3",
  "alkifaf": "الكفاف",
  "alsafouh-first": "السفوح الأولى",
  "world-islands": "جزر العالم",
  "marina": "المارينا",
  "damac-islands": "جزر داماك",
  "al-yelayiss-5": "اليلايس 5",
  "the-heights-country_club": "ذا هايتس كنتري كلوب",
  "the-oasis": "ذا أواسيس",
  "dubai-media-city": "مدينة دبي للإعلام",
  "sheikh-zayed-road-alsafa": "شارع الشيخ زايد، الصفا",
  "damac-hills": "داماك هيلز",
  "wadi-alsafa-3": "وادي الصفا 3",
   "damac-hills-2": "داماك هيلز 2",
  "damac-lagoons": "داماك لاجونز",
  "al-yelayiss-1": "اليلايس 1",
  "dubai-investment-park-2": "مجمع دبي للاستثمار 2",
  "bukadra": "بكادرة",
  "maryam-island": "جزيرة مريم",
  "unknown-district": "منطقة غير معروفة",
  "the-valley": "ذا فالي",
  "rashid-yachts-and-marina": "راشد لليخوت والمرسى",
  "emaar-south": "إعمار الجنوب",
  "siniya-island": "جزيرة السينية",
  "international-city": "المدينة العالمية",
  "downtown": "وسط المدينة",
  "emaar-beachfront": "إعمار بيتش فرونت",
  "dubai-creek-harbour": "ميناء خور دبي",
  "alsafouh-second": "السفوح الثانية",
  "alfaqa": "الفقع",
  "albarsha-south-fifth": "البرشاء جنوب الخامسة",
  "dubai-water-canal": "قناة دبي المائية",
  "alsafa": "الصفا",
   "jumeirah-golf-estatesjge": "عقارات جميرا للجولف (JGE)",
  "dubai-science-park": "مجمع دبي للعلوم",
  "dubai-hills": "دبي هيلز",
  "mina-alarab_hayat_islands": "ميناء العرب، جزر الحياة",
  "hayat-islands": "جزر الحياة",
  "dubai-investment_park": "مجمع دبي للاستثمار",
  "mina-alarab": "ميناء العرب",
  "liwan": "ليوان",
  "jumeirah-island": "جزيرة جميرا",
  "aljurf": "الجرف",
  "alrahmaniya": "الرحمانية",
  "raha-island": "جزيرة الراحة",
  "albarsha-south-fourth": "البرشاء جنوب الرابعة",
  "masdar-city": "مدينة مصدر",
  "expo-city": "مدينة إكسبو",
  "alheerah": "الحيرة",
  "alsuyoh-suburb": "ضاحية السيوح",
  "dubai-harbour": "مرسى دبي",
  "dubai-healthcare_city": "مدينة دبي الطبية",
  "almamzar": "الممزر",
  "dubai-silicon-oasis": "واحة دبي للسيليكون",
  "trade-center-first": "مركز التجارة الأول",
  "sports-city": "مدينة الرياضة",
  "majan": "مجان",
  "dubai-marina": "مرسى دبي",
  "dubai-motor-city": "دبي موتور سيتي",
  "alreem-island": "جزيرة الريم",
  "dubai-downtown": "وسط دبي",
  "international-city-phase-2": "المدينة العالمية - المرحلة الثانية",
  "alsatwa": "السطوة",
  "barsha-heights": "مرتفعات البرشاء",
  "dubai-sports-city": "مدينة دبي الرياضية",
  "jumeirah-2": "جميرا 2",
  "jlt": "أبراج بحيرات جميرا (JLT)",
  "warsan-first": "ورسان الأولى",
  "aljada": "الجادة",
  "alamerah": "العميرة",
  "almanama": "المنامة",
  "alsajaa": "السجع",
  "aljadaf": "الجداف",
  "tilal": "تلال",
  "jabal-ali-first": "جبل علي الأولى",
  "studio-city": "ستوديو سيتي",
  "meydan-d11": "ميدان D11",
  "fahid-island": "جزيرة فاهد",
  "palm-jumeirah": "نخلة جميرا",
  "saadiyat-island": "جزيرة السعديات",
  "ghantoot": "غنتوت",
  "meydan": "ميدان",
  "dubai-international-financial-centre-difc": "مركز دبي المالي العالمي (DIFC)",
  "jvt": "قرية جميرا الدائرية (JVT)",
  "jumeirah-garden-city": "مدينة جميرا جاردن",
  "city-of-arabia": "مدينة العرب",
  "madinat-almataar": "مدينة المطار",
  "yas-island": "جزيرة ياس",
  "mbr-city_d11": "مدينة محمد بن راشد D11",
  "ras-alkhor_ind_first": "رأس الخور الصناعية الأولى",
  "sobha_hartland_2": "شوبا هارتلاند 2",
  "sobha-hartland": "شوبا هارتلاند",
  "dubai-south": "دبي الجنوب",
  "dubai-maritime-city": "مدينة دبي البحرية",
  "alraudah": "الروضة",
  "jabal-ali-industrial-second": "جبل علي الصناعية الثانية",
  "dubai-production-city": "مدينة دبي للإنتاج",
  "reem-island": "جزيرة الريم",
  "dubai-land-residence-complex": "مجمع دبي لاند السكني",
  "jvc": "قرية جميرا الدائرية (JVC)",
  "al-barsha-south-second": "البرشاء جنوب الثانية",
  "dubai-islands": "جزر دبي",
  "muwaileh": "مويلح",
  "arjan": "أرجان",
  "almarjan-island": "جزيرة المرجان",
  "alwasl": "الوصل",
  "alfurjan": "الفرجان",
  "wadi-alsafa-5": "وادي الصفا 5",
  "motor-city": "موتور سيتي",
  "business-bay": "الخليج التجاري",
  "show_all_cities": "عرض جميع المدن"
  },"static": {
  "latest_properties": "أحدث المشاريع",
  "off_plan": "تحت الإنشاء",
  "ready": "جاهز",
  "coming_soon": "قريباً",
  "load_more": "تحميل المزيد",
  "loading": "جاري التحميل...",
  "loading_properties": "جاري تحميل العقارات...",
  "no_properties": "لا توجد عقارات متاحة.",
  "sqft": "قدم مربع",
},
"tabs": {
  "overview": "نظرة عامة",
    "payment_plan": "خطة الدفع",
    "available_units": "الوحدات المتاحة",
    "starting_price": "السعر الابتدائي",
    "area": "المساحة",
    "rooms": "الغرف",
},

  about: {
  heading: "نحن نُحدث تحولًا في كيفية استثمار الناس في العقارات بدبي",
  intro: "منصتنا تربط المشترين بأفضل المطورين في دبي، وتوفر وصولًا سلسًا إلى مشاريع عقارية جاهزة للاستثمار مع تتبع ذكي.",
  mission_title: "مهمتنا",
  mission_1: "نحن ملتزمون بتحسين تجربة شراء العقارات على المخطط في دبي من خلال تقديم قوائم شفافة ورؤى خبيرة وتفاصيل دقيقة.",
  mission_2: "التزامنا يتجاوز القوائم – نبني الثقة ونخلق قيمة طويلة الأمد ونساعد المستثمرين على التنقل بثقة في سوق دبي العقاري الديناميكي.",
  stats: {
    listings: "عقارات على المخطط موثوقة",
    value: "إجمالي قيمة المشاريع",
    partners: "شركاء مطورين موثوقين",
    satisfaction: "رضا العملاء"
  },
  values_title: "قيمنا",
   values: {
    world_class: "كن الأفضل عالميًا",
    insights: "شارك الرؤى",
    innovate: "دائمًا نبتكر",
    supportive: "كن داعمًا",
    responsible: "تحمل المسؤولية",
    enjoy: "استمتع بالرحلة"
  },
  values_desc: {
    world_class: "نقدم قوائم عالية الجودة وتجربة ممتازة.",
    insights: "نزود المستثمرين بأحدث المعلومات.",
    innovate: "نطوّر باستمرار لتلبية متطلبات السوق.",
    supportive: "نوجه كل مشتري في كل خطوة.",
    responsible: "نقف خلف بياناتنا ودعمنا ووعودنا.",
    enjoy: "نؤمن بأن الاستثمار يجب أن يكون مثيرًا ومجزيًا."
  },
  
},

  "property": {
    "foundResults": "وجدنا {{count}} {{type}} تطابق تفضيلاتك.",
    "noResults": "لم يتم العثور على {{type}}"
  },


amenities: {
    "amenities_section_title": "وسائل الراحة والمرافق",
   "Cinema": "سينما",
    "Basketball Playground": "ملعب كرة السلة",
    "BBQ Area": "منطقة الشواء",
    "Children's Swimming Pool": "مسبح الأطفال",
    "Children's Play Area": "منطقة لعب الأطفال",
    "Swimming Pool": "حمام السباحة",
    "Sauna": "ساونا",
    "Gym": "صالة رياضية",
    "Fitness Club": "نادي اللياقة البدنية",
    "Covered Parking": "موقف سيارات مغطى",
    "Garden": "حديقة",
    "Football Playground": "ملعب كرة القدم",
    "Tennis Playground": "ملعب تنس",
    "Jacuzzi": "جاكوزي",
    "Mini Golf": "ميني جولف",
    "Yuga Hall": "قاعة يوغا",
    "Steam room": "غرفة بخار",
    "Paddle Playground": "ملعب البادل",
    "Jogging Track": "مسار الجري",
    "Co-Working Spaces": "مساحات العمل المشتركة",
    "Restaurant": "مطعم",
    "School": "مدرسة",
    "Mosque": "مسجد",
    "Hospital": "مستشفى",
    "Cycling Track": "مسار الدراجات",
    "Club House": "نادي",
    "Table Tennis Court": "ملعب تنس الطاولة",
    "Private Cinema For Each Unit": "سينما خاصة لكل وحدة",
    "Mall": "مركز تسوق",
    "Golf Playground": "ملعب جولف",
    "Playground": "ملعب",
    "Security": "أمن",
    "Opera House": "دار الأوبرا",
    "Cafe": "مقهى",
    "Bicycle Parking": "موقف دراجات",
    "Beauty Saloon": "صالون تجميل",
    "Concierge Service": "خدمة الكونسيرج",
    "Electric Vehicle Charging Stations": "محطات شحن السيارات الكهربائية",
    "Games Lounge Room": "غرفة ألعاب",
    "Beach": "شاطئ",
    "Supermarket": "سوبر ماركت",
    "Pharmacy": "صيدلية",
    "Clinic": "عيادة",
    "Sunken Seating Area": "منطقة جلوس منخفضة",
    "Library": "مكتبة",
    "Squash Courts": "ملاعب الاسكواش",
    "Multipurpose Hall": "قاعة متعددة الاستخدامات",
    "Water Fountain": "نافورة مياه",
    "Retail Shops": "محلات تجارية",
    "Meeting Rooms": "غرف اجتماعات",
    "Dog Park": "منتزه الكلاب",
    "Veterinary Clinic": "عيادة بيطرية",
    "Volleyball Playground": "ملعب كرة الطائرة",
    "Traverse Climbing Walls": "جدران تسلق",
    "Cabana Seating": "مقاعد كابانا",
    "VR Game Room": "غرفة ألعاب الواقع الافتراضي",
    "Snow Rooms": "غرف الثلج",
    "Sitting Area": "منطقة جلوس",
    "Music Room": "غرفة الموسيقى",
    "Badminton Court": "ملعب الريشة",
    "Theater": "مسرح",
    "Private Parking For Each Unit": "موقف خاص لكل وحدة",
    "Bocce Play Area": "منطقة لعب بوتشي",
    "Smart Homes": "منازل ذكية",
    "Skate Park": "حديقة التزلج",
    "Pet Shop": "محل حيوانات أليفة",
    "Nursery": "حضانة"
  }
  ,
  
  "thank_you_page": {
    "thank_you": "شكراً!",
    "message": "تم استلام رسالتك. سنتواصل معك قريباً.",
    "back_to_home": "العودة إلى الصفحة الرئيسية"
  },


  
  "contact_form": {
    "get_in_touch": "اتصل بنا",
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "select_role": "اختر دورك",
    "select_role_placeholder": "-- اختر --",
    "agent": "وكيل",
    "buyer": "مشتري",
    "just_exploring": "مجرد استكشاف",
    "message": "الرسالة",
    "send_message": "إرسال الرسالة",
    "sending": "جاري الإرسال...",
    "failed_message": "فشل في إرسال الرسالة.",
    "error_message": "حدث خطأ أثناء إرسال رسالتك.",
    "default_message": "أنا مهتم بهذه العقار",
    "please_contact_me": "يرجى الاتصال بي"
  }
,


 exclusive_projects: "مشاريع حصرية",
 latest_projects: "أحدث المشاريع",


          }
      }
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
